import {
  Links,
  Meta,
  Scripts,
  ScrollRestoration,
  useLocation,
} from 'react-router'
import clsx from 'clsx'
import type { ReactNode } from 'react'
import { SupportedLanguages } from '~/config/i18n'
export const SharedLayout = ({
  children,
  lang = SupportedLanguages.English,
}: {
  children: ReactNode
  lang: SupportedLanguages
}) => {
  const { pathname } = useLocation()

  return (
    <html lang={lang}>
      <head>
        {/* `<Meta />` emits `<meta charSet>` first; it must stay ahead of
            `<Links />` so the encoding declaration lands in the first 1024
            bytes rather than behind the stylesheet and preload tags. */}
        <Meta />
        <Links />
      </head>
      <body
        className={clsx(
          pathname === '/' ? 'home' : 'page',
          pathname.split('/'),
        )}
      >
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}
